// {
//   "name": "component-iconic-parallax.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-parallax-image-with-text-first')) {
    return;
  }

  class IconicParallaxImageWithTextFirst extends HTMLElement {
    constructor() {
      super();

      this.PARALLAX_SPEED = 0.3;
      this.visibleElements = new Set();
      this.parallaxRunning = false;

      this.observer = new IntersectionObserver(
        this.handleIntersect.bind(this)
      );
    }

    connectedCallback() {
      this.observeElements();
      this.initMutationObserver();
    }

    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.visibleElements.add(entry.target);
        } else {
          this.visibleElements.delete(entry.target);
        }
      });
    }

    updateParallax() {
      this.visibleElements.forEach((el) => {
        if (!el.classList.contains('animate--parallax')) return;

        const img = el.querySelector('img, svg');
        if (!img) return;

        const rect = el.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        const progress =
          (windowHeight - rect.top) / (windowHeight + rect.height);
        const clampedProgress = Math.max(0, Math.min(1, progress));

        const offset =
          (clampedProgress - 0.5) *
          rect.height *
          this.PARALLAX_SPEED;

        img.style.transform = 'translateY(' + offset + 'px)';
      });

      if (this.parallaxRunning) {
        requestAnimationFrame(this.updateParallax.bind(this));
      }
    }

    observeElements() {
      const parallaxEls = this.querySelectorAll('.animate--parallax');

      parallaxEls.forEach((el) => {
        this.observer.observe(el);
      });

      if (parallaxEls.length > 0 && !this.parallaxRunning) {
        this.parallaxRunning = true;
        requestAnimationFrame(this.updateParallax.bind(this));
      }
    }

    initMutationObserver() {
      const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'style'
          ) {
            const target = mutation.target;
            if (target.style.display !== 'none') {
              this.observeElements();
            }
          }
        });
      });

      mutationObserver.observe(this, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }
  }

  customElements.define(
    'iconic-parallax-image-with-text-first',
    IconicParallaxImageWithTextFirst
  );
})();
